import { Grid, Box } from '@chakra-ui/react';
import { Modal } from '.';

interface IModalColumnsProps {
  id: string;
  onClose: () => void;
  size?: string;
  hideFooter?: boolean;
  title?: string;
  children?: React.ReactNode;
  supportingColumn?: React.ReactNode;
}

const ModalColumns = (props: IModalColumnsProps) => {
  const { id, onClose, size = '4xl', hideFooter = true, title, children, supportingColumn } = props;

  return (
    <Modal id={id} show={true} title={title} onClose={onClose} size={size} hideFooter={hideFooter}>
      <Grid id="innerModal" gridTemplateColumns={{ base: 'none', md: '1.33fr 1fr' }} columnGap={8} rowGap={6}>
        <Box as="article">{children}</Box>

        {supportingColumn ? (
          <Box as="aside" gridRowStart={{ base: '-1', md: 'initial' }}>
            {supportingColumn}
          </Box>
        ) : null}
      </Grid>
    </Modal>
  );
};

export { ModalColumns };
